import { ENDPOINTS } from '../../network/endpoints';

/** @implements {import('../../../contracts/IAgentsRepository').IAgentsRepository} */
export class AgentsRepository {
  /** @param {import('../../../contracts/IHttpClient').IHttpClient} client */
  constructor(client) {
    this.client = client;
  }

  async getAgents(options = {}) {
    const response = await this.client.get(ENDPOINTS.AGENTS.BASE, {
      params: options,
    });
    return response.agents;
  }

  async createAgent(agentConfig) {
    return this.client.post(ENDPOINTS.AGENTS.BASE, agentConfig);
  }

  async getAgentById(agentId) {
    return this.client.get(ENDPOINTS.AGENTS.BY_ID(agentId));
  }

  async updateAgent(agentId, updateData) {
    return this.client.put(ENDPOINTS.AGENTS.BY_ID(agentId), updateData);
  }

  async deleteAgent(agentId) {
    return this.client.delete(ENDPOINTS.AGENTS.BY_ID(agentId));
  }

  async duplicateAgent(sourceAgentId, newSettings) {
    return this.client.post(ENDPOINTS.AGENTS.DUPLICATE(sourceAgentId), newSettings);
  }
}
